import { TranslationDictionary, TranslationSet } from './types';
import { Language } from '@/contexts/language';

import { common } from './features/common';
import { gallery } from './features/gallery';
import { landing } from './features/landing';
import { footer } from './features/footer';
import { index } from './features/index';
import { benefits } from './features/benefits';
import { entries } from './features/entries';
import { generate } from './features/generate';
import { premium } from './features/premium';
import { auth } from './features/auth';
import { statistics } from './features/statistics';
import { profile } from './features/profile';
import { features } from './features/features';
import { baby } from './features/baby';
import { family } from './features/family';
import { notFound } from './features/notFound';
import { login } from './features/login';
import { signup } from './features/signup';
import { password } from './features/password';
import { chatbot } from './features/chatbot';

// Combine all translation sets
const translations: Record<string, TranslationSet> = {
  common,
  gallery,
  landing,
  footer,
  index,
  benefits,
  entries,
  generate,
  premium,
  auth,
  statistics,
  profile,
  features,
  baby,
  family,
  notFound,
  login,
  signup,
  password,
  chatbot
};

// Translation function
export const t = (key: string, language: Language): string => {
  const translationSet = translations[key.split('.')[0]];
  if (translationSet && translationSet[key]) {
    const translation = translationSet[key][language];
    return translation || translationSet[key]['en'] || key;
  }
  return key;
};

// Function to get all translations for a specific language
export const getAllTranslations = (language: Language): TranslationDictionary => {
  const allTranslations: TranslationDictionary = {};
  Object.keys(translations).forEach(feature => {
    const translationSet = translations[feature];
    Object.keys(translationSet).forEach(key => {
      const translation = translationSet[key][language];
      allTranslations[key] = translation || translationSet[key]['en'] || key;
    });
  });
  return allTranslations;
};
